var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Water stream") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M5.194 13.83a1.5 1.5 0 0 1-1.388-2.66c8.135-4.244 15.398-4.244 21.559.105 1.637 1.155 3.108 2.433 4.584 3.933 1.16 1.178 4.579 5.046 4.506 4.967C37.658 23.657 40.038 25 44 25c4.028 0 7.213-.91 9.6-2.7a1.5 1.5 0 1 1 1.8 2.4C52.453 26.91 48.638 28 44 28c-4.93 0-8.034-1.751-11.753-5.794.025.027-3.343-3.784-4.436-4.894-1.358-1.379-2.695-2.541-4.176-3.587-5.173-3.65-11.243-3.65-18.441.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M4.194 23.83a1.5 1.5 0 0 1-1.388-2.66c8.135-4.244 15.398-4.244 21.559.105 1.637 1.155 3.108 2.433 4.584 3.933 1.16 1.178 4.579 5.046 4.506 4.967C36.658 33.657 39.038 35 43 35c4.028 0 7.213-.91 9.6-2.7a1.5 1.5 0 1 1 1.8 2.4C51.453 36.91 47.638 38 43 38c-4.93 0-8.034-1.751-11.753-5.794.025.027-3.343-3.784-4.436-4.894-1.358-1.379-2.695-2.541-4.176-3.587-5.173-3.65-11.243-3.65-18.441.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M2.194 33.83a1.5 1.5 0 0 1-1.388-2.66c8.135-4.244 15.398-4.244 21.559.105 1.637 1.155 3.108 2.433 4.584 3.933 1.16 1.178 4.579 5.046 4.506 4.967C34.658 43.657 37.038 45 41 45c4.028 0 7.213-.91 9.6-2.7a1.5 1.5 0 1 1 1.8 2.4C49.453 46.91 45.638 48 41 48c-4.93 0-8.034-1.751-11.753-5.794.025.027-3.343-3.784-4.436-4.894-1.358-1.379-2.695-2.541-4.176-3.587-5.173-3.65-11.243-3.65-18.441.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterStream);
export default __webpack_public_path__ + "static/media/water-stream.516e5baf3d17fc0edfa29aa89119ae01.svg";
export { ForwardRef as ReactComponent };